import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";

import { SharedRoutingModule } from "./shared-routing.module";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { DeleteModalComponent } from "./components/delete-modal/delete-modal.component";
import { PlanDeleteModalComponent } from "./components/plan-delete-modal/plan-delete-modal.component";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { Ng5SliderModule } from "ng5-slider";
import { ErrorModalComponent } from "./components/error-modal/error-modal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QRCodeModule } from "angularx-qrcode";

import {
  BsDatepickerConfig,
  BsDatepickerModule,
  DatepickerModule,
} from "ngx-bootstrap/datepicker";
import { RefundModalComponent } from "./components/refund-modal/refund-modal.component";
import { ApproveRejectReasonComponent } from "./components/approve-reject-reason/approve-reject-reason.component";
import { InviteMemberComponent } from "./components/invite-member/invite-member.component";
import { AddPaymentModalComponent } from "./components/add-payment/add-payment-modal.component";
import { PageTypeModalComponent } from "./components/page-type/page-type-modal.component";
import { AddPlansComponent } from "./components/add-plans/add-plans.component";
import { AddCustomRoleComponent } from "./components/add-custom-role/add-custom-role.component";
import { AddProductComponent } from "./components/add-product/add-product.component";
import { SubscriptionPaymentTypeComponent } from "./components/subscription-payment-type/subscription-payment-type.component";
import { UploadMediaComponent } from "./components/upload-media/upload-media.component";
import { AddCustomerComponent } from "./components/add-customer/add-customer.component";
import { PaymentModalComponent } from "./components/payment-modal/payment-modal.component";
import { BankComponent } from "./components/payment-modal/bank/bank.component";
import { CardDetailComponent } from "./components/payment-modal/card-detail/card-detail.component";
import { TransferComponent } from "./components/payment-modal/transfer/transfer.component";
import { DeclineModelComponent } from "./components/decline-model/decline-model.component";
import { SuccessModelComponent } from "./components/success-model/success-model.component";
import { UpdateOrderStatusComponent } from "./components/update-order-status/update-order-status.component";
import { AddProductModalComponent } from "./components/add-product-modal/add-product-modal.component";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { CreateInvoiceComponent } from "./components/create-invoice/create-invoice.component";
import { ViewInvoiceComponent } from "./components/view-invoice/view-invoice.component";
import { UssdComponent } from "./components/payment-modal/ussd/ussd.component";
import { SubscriptionExistingPlanComponent } from "./components/subscription-existing-plan/subscription-existing-plan.component";
import { SubscriptionNewPlanComponent } from "./components/subscription-new-plan/subscription-new-plan.component";
import { SubscriptionCustomerCreatePlanComponent } from "./components/subscription-customer-create-plan/subscription-customer-create-plan.component";
import { SuccessModelCreatedComponent } from "./components/success-model-created/success-model-created.component";
import { HtmlContentPipe } from "./html-content.pipe";
import { EditTransferComponent } from "./components/edit-transfer/edit-transfer.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { NqrComponent } from "./components/payment-modal/nqr/nqr.component";
import { TopupModalComponent } from "./components/topup-modal/topup-modal.component";
import { ReadonlyDatepickerDirective } from './readonly-datepicker.directive';
import { ClickOutsideDirective } from "./directives/out-side-event.directive";
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    dateInputFormat: "YYYY-MM-DD",
    placement: "top",
  });
}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    DeleteModalComponent,
    PlanDeleteModalComponent,
    ErrorModalComponent,
    RefundModalComponent,
    ApproveRejectReasonComponent,
    InviteMemberComponent,
    AddPaymentModalComponent,
    PageTypeModalComponent,
    AddPlansComponent,
    AddCustomRoleComponent,
    AddProductComponent,
    SubscriptionPaymentTypeComponent,
    UploadMediaComponent,
    AddCustomerComponent,
    PaymentModalComponent,
    BankComponent,
    CardDetailComponent,
    TransferComponent,
    DeclineModelComponent,
    SuccessModelComponent,
    UpdateOrderStatusComponent,
    AddProductModalComponent,
    CreateInvoiceComponent,
    ViewInvoiceComponent,
    UssdComponent,
    SubscriptionExistingPlanComponent,
    SubscriptionNewPlanComponent,
    SubscriptionCustomerCreatePlanComponent,
    SuccessModelCreatedComponent,
    HtmlContentPipe,
    EditTransferComponent,
    NqrComponent,
    TopupModalComponent,
    ReadonlyDatepickerDirective,
    ClickOutsideDirective,
    PageNotFoundComponent,
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    SharedRoutingModule,
    NgxTrimDirectiveModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    Ng5SliderModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    FormsModule,
    Ng2SearchPipeModule,
    QRCodeModule,
  ],
  exports: [
    TranslateModule,
    DeleteModalComponent,
    PlanDeleteModalComponent,
    NgxTrimDirectiveModule,
    Ng5SliderModule,
    DatePipe,
    ErrorModalComponent,
    BsDatepickerModule,
    DatepickerModule,
    RefundModalComponent,
    ApproveRejectReasonComponent,
    InviteMemberComponent,
    AddPaymentModalComponent,
    PageTypeModalComponent,
    AddPlansComponent,
    AddCustomRoleComponent,
    AddProductComponent,
    SubscriptionPaymentTypeComponent,
    UploadMediaComponent,
    AddCustomerComponent,
    PaymentModalComponent,
    BankComponent,
    CardDetailComponent,
    TransferComponent,
    DeclineModelComponent,
    SuccessModelComponent,
    UpdateOrderStatusComponent,
    AddProductModalComponent,
    Ng2SearchPipeModule,
    CreateInvoiceComponent,
    ViewInvoiceComponent,
    HtmlContentPipe,
    EditTransferComponent,
    TopupModalComponent,
    ReadonlyDatepickerDirective,
    ClickOutsideDirective,
    PageNotFoundComponent,
  ],
  providers: [
    {
      provide: BsDatepickerConfig,
      useFactory: getDatepickerConfig,
    },
    Ng5SliderModule,
    DatePipe,
  ],
})
export class SharedModule {
  constructor(private translate: TranslateService) {
    translate.addLangs(["en"]);
    const language =
      JSON.parse(window.localStorage.getItem("language")) || "en";
    translate.setDefaultLang(language);
    translate.use(language);
  }
}
